<template>
  <div>
    <el-row style="margin-bottom: 0.1rem">
      <el-col :span="24">
        <span class="count-span" v-for="(item, index) in companyCountData" :key="index">
          {{ item.label }}:{{ item.value }}
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'CompanyRisksCount',
  components: {
  },
  props: {
    companyCountData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
  },
  computed: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
.count-span {
  margin-right: .2rem;
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/CompanyRisksCount.vue